// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";

// Components
const PublicProductItemCard = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "public-product-item-card" */ "@/app/views/client-view/public-products-page/components/public-product-item-card/public-product-item-card.vue"
    );

export default {
    name: "PublicCartCard",
    components: { PublicProductItemCard },
    directive: {},
    filters: {},
    mixins: [toastMessageMixins],
    props: {
        product: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            ageList: {
                A: "Adult",
                P: "Puppy",
            },
            isReadMore: false,

            currentProduct: this.product,
        };
    },
    computed: {},
    watch: {},
    created() {},
    methods: {
        getProductImage() {
            let imgUrl = require("@/assets/images/product/dog-default-picture-color.png");
            if (!this.currentProduct.isCustomBundle) {
                for (const key in this.currentProduct.products) {
                    const product = this.currentProduct.products[key];
                    if (product.productImg) {
                        imgUrl = product.productImg;
                        break;
                    }
                }
            } else {
                if (this.currentProduct.bundleImg) {
                    imgUrl = this.currentProduct.bundleImg;
                }
            }
            return imgUrl;
        },
        getProductPrice() {
            const price = this.product.onSale ? this.product.salePrice : this.product.price;
            return price * this.currentProduct.quantity || 1;
        },
        showImageModal() {
            this.$swal({
                imageHeight: 250,
                imageUrl: this.getProductImage(),
                imageAlt: "Image",
                title: this.currentProduct.name,
                text: this.currentProduct.description ? this.currentProduct.description : "",
            });
        },
        readMoreAndModal() {
            this.showImageModal();
        },
        setBundleQty(event, type) {
            let currentQuantity = this.currentProduct.quantity || 1;
            let newQuantity = currentQuantity;

            if (type === "decrease") {
                currentQuantity -= 1;
                newQuantity = currentQuantity < 1 ? 1 : currentQuantity;
            } else if (type === "increase") {
                currentQuantity += 1;
                newQuantity = currentQuantity > 999 ? 999 : currentQuantity;
            } else if (type === "input") {
                if (event.target.value && parseFloat(event.target.value) > 999) {
                    event.target.value = this.currentProduct.quantity;
                } else if (event.target.value.trim() === "") {
                    event.target.value = this.currentProduct.quantity;
                } else if (event.target.value !== this.currentProduct.quantity) {
                    newQuantity = event.target.value;
                }
            }

            // get original price and sale price from the "product" props instead of the currentProduct
            this.currentProduct = {
                ...this.currentProduct,
                quantity: parseInt(newQuantity),
                price: parseFloat(this.product.price) * newQuantity,
                salePrice: this.product.onSale ? parseFloat(this.product.salePrice) * newQuantity : 0,
            };

            this.$store.dispatch("updatePublicCartProduct", this.currentProduct);
        },
        numberOnlyInput(event) {
            const charCode = event.which ? event.which : event.keyCode;

            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
            } else {
                return true;
            }
        },
        stocksAvailable(stockQty) {
            return stockQty <= 0 || stockQty === null ? "Out of Stock" : `Available Qty: ${stockQty}`;
        },
        removeProductFromCart() {
            this.$emit("removeProductFromCart", this.currentProduct.bundleId);
        },
    },
};
